import {
  initializeSimulation,
  InitializeSimulationPayload,
  InitializeSimulationResponse
} from '@/modules/simulator/api'
import { useMutation } from '@tanstack/react-query'
import { useContext } from 'react'
import {
  SimulatorContext,
  SimulatorDispatchContext
} from '@/modules/simulator/contexts'
import { addError } from '@/global/plugins/observability'
import {
  Context,
  SimulatorCode
} from '@/global/plugins/observability/observability.constants'
import { useSearchParams } from 'next/navigation'
import { getTrackingInfoUtms } from '@/modules/simulator/functions/getTrackingInfoUtms/getTrackingInfoUtms'
import { toast } from 'react-toastify'
import { sendGTMEvent } from '@next/third-parties/google'

const useInitSimulation = () => {
  const searchParams = useSearchParams()
  const { simulationDispatch } = useContext(SimulatorDispatchContext)
  const { simulatorVersion } = useContext(SimulatorContext)

  const initSimulationPayload: InitializeSimulationPayload = {
    version: simulatorVersion.value!,
    trackingInfo: searchParams ? getTrackingInfoUtms(searchParams) : {}
  }

  const onSuccess = (data: InitializeSimulationResponse) => {
    sendGTMEvent({ event: 'simulator_form_initialized' })

    simulationDispatch({ type: 'SET_ID', payload: { id: data.simulation.id } })
  }

  const onError = (error: Error) => {
    addError({
      error,
      data: {
        context: Context.SIMULATOR,
        code: SimulatorCode.INITIALIZE_SIMULATION_ERROR,
        message: `Erro ao inicializar simulação na versão ${simulatorVersion.value}`
      }
    })

    toast(
      'Ops! Tivemos um problema ao carregar o simulador. Tente novamente mais tarde'
    )
  }

  return useMutation<InitializeSimulationResponse, Error>({
    mutationFn: () => initializeSimulation(initSimulationPayload),
    onSuccess,
    onError
  })
}

export { useInitSimulation }
